import { controls, grouped, recovery_percentage } from "../../controls";
import moment from "moment";

const recovery = {
  label: "recovery report",
  starting: true,
  url: "recovery ",
  pageLabel: "recovery report",
  pageType: "history",
  filter: [/*
     ...controls.displayText({ tab: "filter", label: "Branch" }),
     ...controls.oc({ tab: "filter", length: 4, c: "Branch", defaultValue: "assigned_branch", placeHolder: "Branch Code", name:
      "branch_code", fastpath: "branches" }),
     ...controls.showData({ tab: "filter", displaytype: "capital", data: "branch_display" }),
 
     ...controls.magicDateLabel({ label: "", width: "col-sm-1" }),
     
     ...controls.displayText({ tab: "general", width: "col-sm-1", label: "Account" }),
     ...controls.oc({ tab: "general", width: "col-sm-2", c: "Account", placeHolder: "Account Number", name: "account_code", fastpath: "accounts" }),
     ...controls.showData({ tab: "general", width: "col-sm-2", displaytype: "capital", data: "account_display" }),
     
 
     ...controls.magicDateLabel({ label: "From Date", width: "col-sm-2", target: "from_date" }),
     ...controls.magicDate({ dateType: "ontype", isRequired: true, name: "from_date", width: "col-sm-2" }),
     ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),
     
     ...controls.magicDateLabel({ label:"To Date", width:"col-sm-2", target:"to_date" }),
     ...controls.magicDate({ dateType: "ontype", isRequired: true, name:"to_date", width: "col-sm-2" }),
     ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),
 
 */

  ],
  form: [],

  history: {
    perPage: 10,
    reportHeader: "recovery report",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: false,
    extraRows: {
      location: "top",
      fields: ["old_ovd", "old_rec", "old_total", "new_ovd", "new_rec", "new_total", "cur_ovd", "cur_rec", "cur_total", "rec_new", "rec_int"],
      grandtotal: { type: "fixed", displayIn: "prname", val: "Grand Total", count: true },
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
      },

      {
        Header: "CODE NO.",
        accessor: "code",
        width: "*"
      },

      {
        Header: "LOAN TYPE",
        accessor: "prname",
        width: "*"
      },
      {
        Header: "RECOVERABLE DUES",
        columns: [
          {
            Header: "OVERDUES AMOUNT",
            accessor: "Old_Ovd",
            type: "currency"
          },
          {
            Header: "CURENT AMOUNT",
            accessor: "Old_Rec",
            type: "currency"
          },
          {
            Header: "TOTAL AMOUNT",
            accessor: "Old_Total",
            type: "currency"
          },
        ]
      },
      {
        Header: "RECOVERY UP TO LAST WEEK",
        columns: [
          {
            Header: "OVERDUES",
            accessor: "New_Ovd",
            type: "currency"
          },
          {
            Header: "CURENT",
            accessor: "New_Rec",
            type: "currency"
          },
          {
            Header: "TOTAL",
            accessor: "New_Total",
            type: "currency"
          },
        ]
      },
      {
        Header: "RECOVERY DURING  CURRENT WEEK",
        columns: [
          {
            Header: "OVERDUES",
            accessor: "Cur_Ovd",
            type: "currency"
          },

          {
            Header: "CURENT",
            accessor: "Cur_Rec",
            type: "currency"
          },


          {
            Header: "TOTAL",
            accessor: "Cur_Total",
            type: "currency"
          },
        ]
      },
      {
        Header: "TOTAL  RECOVERY SEASON",
        columns: [
          {
            Header: "OVERDUES AMOUNT",
            accessor: "total_recovery_overdue_amount",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'New_Ovd' },
              { source: 'row', field: 'Cur_Ovd' },

              ], resultVar: 'total'
            }],
            type: "currency"
          },
          {
            Header: "CURENT AMOUNT",
            accessor: "total_recovery_current_amount",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'New_Rec' },
              { source: 'row', field: 'Cur_Rec' },

              ], resultVar: 'total'
            }],
            type: "currency"
          },
          {
            Header: "TOTAL AMOUNT",
            accessor: "total_amount",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'New_Total' },
              { source: 'row', field: 'Cur_Total' },

              ], resultVar: 'total'
            }],
            type: "currency"
          },
        ]
      },

      {
        Header: "BALANCE OF RECOVERABLE DUES",
        columns: [
          {
            Header: "OVERDUES AMOUNT",
            accessor: "balances_of_recovery_due_overdue_amount",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'New_Ovd' },
              { source: 'row', field: 'Cur_Ovd' },
              { source: 'allResults', field: 'Old_Ovd', mult: { source: "fixed", field: 'mult', fixed: { mult: -1 } } }
              ], resultVar: 'total'
            }],
            type: "currency"
          },
          {
            Header: "CURENT AMOUNT",
            accessor: "balances_of_recovery_due_current_amount",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [
                { source: 'allResults', field: 'Cur_Rec', mult: { source: "fixed", field: 'mult', fixed: { mult: -1 } } },
                { source: 'row', field: 'New_Rec' },
                { source: 'row', field: 'Cur_Rec' },

              ], resultVar: 'total'
            }],
            type: "currency"
          },
          {
            Header: "TOTAL AMOUNT",
            accessor: "balances_of_recovery_due_total_amount",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [
                { source: 'allResults', field: 'Old_Total', mult: { source: "fixed", field: 'mult', fixed: { mult: -1 } } },
                { source: 'row', field: 'New_Total' },
                { source: 'row', field: 'Cur_Total' }

              ], resultVar: 'total'
            }],
            type: "currency"
          },
        ]
      },

      {
        Header: "OVERDUES END OF WEEK",
        accessor: "overude_end_of_week",
        formula: [{
          f: 'simpleArithmatic', calcType: 'sum', inputs: [

            { source: 'allResults', field: 'Old_Ovd', mult: { source: "fixed", field: 'mult', fixed: { mult: -1 } } },
            { source: 'row', field: 'New_Ovd' },
            { source: 'row', field: 'Cur_Ovd' }
          ], resultVar: 'total'
        }],
        type: "currency"
      },
      {
        Header: "ADVANCE RECOVERY",
        accessor: "advance_recovery",
        formula: [{
          f: 'simpleArithmatic', calcType: 'sum', inputs: [
            { source: 'allResults', field: 'Old_Ovd', mult: { source: "fixed", field: 'mult', fixed: { mult: -1 } } },
            { source: 'row', field: 'New_Ovd' },
            { source: 'row', field: 'Cur_Ovd' }

          ], resultVar: 'total'
        }],
        type: "currency"
      },

      {
        Header: "RECOVERY PERCENTAGE",
        accessor: "recovery_percentage",
        formula: [{
          f: 'runFormula', calcType: recovery_percentage, inputs: [], resultVar: 'total'
        }],

        type: "currency"
      },

      {
        Header: "RECOVERY OF INTEREST",
        accessor: "Rec_Int",
        type: "currency"
      },


      /*  {
         Header: "Balance",
         accessor: "balance",
         width132: { size: 13, },
         formula: [{
           f: 'simpleArithmatic', calcType: 'colSum', inputs: [{ source: 'row', field: 'credit' }, { source: 'row', field: 'debit' }
           ], resultVar: 'total'
         }],
         type: "currency",
       },*/


    ]
  }
};

export default recovery;